import React from "react";

import './style.scss';

interface PropsInterface {
  className?: string;
  children: React.ReactNode;
}

export const RightSidebar = ({ className, children }: PropsInterface) => (
  <div className={`v-right-sidebar ${className || ''}`}>
    {children}
  </div>
)
